module.exports = __webpack_public_path__ + "img/repeat_dot2x.png?c6a0be2a9bc5044552e1f67591367a0c";